import React, { useContext, useRef } from 'react'
import { useForm, SubmitHandler } from "react-hook-form";
import { Link, useNavigate, useParams } from 'react-router-dom';
import APIEndpoints from '../config';
import { useState } from 'react';
import {GlobalContext} from './GlobalContext.tsx';

interface IFormNewPassword {
    id:string;
    token:string;
    accountPassword:string;
    accountRePassword:string;
  }

export function FormSetNewPasswordPage(){
    const { register, handleSubmit, formState: {errors}, setError } = useForm<IFormNewPassword>();
    const [isSubmitting,setIsSubmitting] = useState(false);
    let { id, token } = useParams();
    const {globalDispatch} = useContext(GlobalContext);
    const navigate = useNavigate();

    const onSubmit: SubmitHandler<IFormNewPassword> = (e) => {
      setIsSubmitting(true);
      fetch(APIEndpoints.newPassword,{
        method:'POST',
        body:JSON.stringify(e),
        headers: {
        'Accept': 'application/json',
        "X-Requested-With": "XMLHttpRequest",
      },})
        .then(response => response.json())
        .then(data => {
          setIsSubmitting(false);
          if (data.messages){
            Object.keys(data.messages).map((k,i) => {
              Object.keys(data.messages[k]).map((m) => {
                setError(k, { type: "validate", message: data.messages[k][m] })
              });
            });
          }
          if (data.flashMessages){
            globalDispatch({type:'SET_MESSAGES',flashMessages:data.flashMessages});
//            console.log(data.flashMessages);
            const hasErrors = data.flashMessages.filter(e=>e.type==='danger');
            console.log(hasErrors);
            if (!hasErrors.length)
              navigate("/");
          }
        })
        .catch(error => console.error(error));
    };

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" {...register("id",{required:true,value:id!})} />
        <input type="hidden" {...register("token",{required:true,value:token!})} />
        <div className="form-floating mb-3">
          <input disabled={isSubmitting} type="password" className={errors.accountPassword ? 'form-control is-invalid': 'form-control'} id="loginUserPassword" placeholder="Hasło do logowania" 
          {...register("accountPassword", { required: true, minLength: {
            value: 6,
            message: "Hasło jest za krótkie."
          } })} />
          <label htmlFor="loginUserPassword">Hasło</label>
          <div className="invalid-feedback">{errors.accountPassword && errors.accountPassword.message}</div>
        </div>
        <div className="form-floating mb-3">
          <input disabled={isSubmitting} type="password" className={errors.accountRePassword ? 'form-control is-invalid': 'form-control'}  id="loginUserRePassword" placeholder="Hasło do logowania" 
          {...register("accountRePassword", { required: true, 
            validate: (value, { accountPassword }) => {//return true;
              if (accountPassword!==value) {
                return 'Hasła nie są takie same.';
              }
              return true;
            },
            minLength: {
            value: 6,
            message: "Hasło jest za krótkie.",
          } })} />
          <label htmlFor="loginUserRePassword">Powtórz hasło</label>
          <div className="invalid-feedback">{errors.accountRePassword && errors.accountRePassword.message}</div>
        </div>
    
          <div className="d-grid">
            <button className="btn btn-lg btn-primary btn-login text-uppercase fw-bold mb-2" type="submit">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>} Stwórz konto
            </button>
            <div className="text-center">
              <Link to={'/nowe-haslo'} className="small btn btn-xs">Przypomnieć hasło?</Link> |  <Link to={'/'} className="small btn btn-xs">Powrót do logowania</Link>
            </div>
          </div>
                    <div className="text-center my-2">
                      <Link to={'/dlaczego-warto'} className="small btn btn-xs  btn-primary fw-bold mb-2 ">Dlaczego warto?</Link>
                    </div>
    
        </form>
      );
}